module.exports = __webpack_public_path__ + "feb3566d9cf271c169fcc9154abf59c6.svg";